import { create } from 'zustand'

/**
 * Whether the app's side nav (and mobile top bar) is hidden on
 * `/benefits/election`.
 *
 * The guided severance flow draws its election screens full-screen, but it is a
 * lazy page: until its chunk has loaded and rendered, the layout around it has
 * already painted. Hiding the nav from the layout, with a default of hidden,
 * means there is no frame where it shows and then vanishes. The page flips this
 * off once the employee is past signing, and back on when it unmounts.
 */
interface SeveranceElectionState {
  navHidden: boolean
  setNavHidden: (hidden: boolean) => void
}

export const useSeveranceElectionStore = create<SeveranceElectionState>((set) => ({
  navHidden: true,
  setNavHidden: (navHidden) => set({ navHidden }),
}))
